module.exports = __webpack_public_path__ + "img/D201403_2.2c40cfae.jpg";